export const getTodayDate = () => {
  const today = new Date()
  const month = today.getMonth()
  const year = today.getFullYear()
  return {today, month, year}
}
